function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { Heading, Link, Paragraph, Strong } from "@brandwatch/axiom-components";
import { translate } from "@brandwatch/axiom-localization";
import LogoPage from "../LogoPage/LogoPage";
import StatusMessage from "./StatusMessage";
const t = translate({
  "about the problem": {
    de: "über das Problem",
    es: "sobre el problema",
    fr: "à propos du problème"
  },
  "contact us": {
    de: "kontaktiere uns",
    es: "contáctenos",
    fr: "contactez nous"
  },
  "home page": {
    de: "startseite",
    es: "página principal",
    fr: ""
  },
  "Ooops!": {
    de: "Hoppla!",
    es: "Huy!",
    fr: "page d'accueil"
  },
  or: {
    de: "oder",
    es: "o",
    fr: "ou"
  },
  "The link you clicked may be broken or the page may have been removed": {
    de: "Der Link, den Sie geklickt haben, kann kaputt sein oder die Seite wurde möglicherweise" + " entfernt",
    es: "El enlace al que ha hecho clic puede estar roto o la página puede haber sido eliminada",
    fr: "Le lien sur lequel vous avez cliqué peut être brisé ou si la page a été supprimée"
  },
  "Visit the": {
    de: "Besuche den",
    es: "Visita el",
    fr: "Visiter le"
  }
});
export default class Status404 extends Component {
  render() {
    const {
      axiomLanguage
    } = this.context;
    const {
      contactUsLocation,
      homeLocation,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(LogoPage, rest, /*#__PURE__*/React.createElement(StatusMessage, null, /*#__PURE__*/React.createElement(Heading, {
      space: "x4",
      textSize: "display1"
    }, /*#__PURE__*/React.createElement(Strong, null, t("Ooops!", axiomLanguage))), /*#__PURE__*/React.createElement(Heading, {
      space: "x4",
      textSize: "headline"
    }, t("The link you clicked may be broken or " + "the page may have been removed", axiomLanguage)), /*#__PURE__*/React.createElement(Paragraph, {
      space: "x4"
    }, t("Visit the", axiomLanguage), " ", /*#__PURE__*/React.createElement(Link, {
      href: homeLocation
    }, t("home page", axiomLanguage)), " ", t("or", axiomLanguage), " ", /*#__PURE__*/React.createElement(Link, {
      href: contactUsLocation
    }, t("contact us", axiomLanguage)), " ", t("about the problem", axiomLanguage), ".")));
  }

}

_defineProperty(Status404, "contextTypes", {
  axiomLanguage: PropTypes.string
});